import { Stack } from "@mui/material";

import PaginationControlsV2 from "../../../../../global/PaginationControlsV2";
import HNSColors from "../../../../../ui library/HNSColors";
import { useAvailableServicesStore } from "../../store/services-provided/availableServicesStore";
import { useServicesStore } from "../../store/services-provided/servicesStore";
import STRINGS from "../../utils/strings";
import LoadingIndicator from "../fields/LoadingIndicator";
import SearchBar from "../fields/SearchBar";

import ServicesHeader from "./ServicesHeader";
import ServicesList from "./ServicesList";

export default function AvailableServices() {
  const {
    data,
    loading,
    currentSearch,
    setCurrentSearch,
    resultCount,
    currentPage,
    resLimit,
    setCurrentPage,
    resetCurrentPage,
  } = useAvailableServicesStore();
  const { selectedAvailableServices } = useServicesStore();
  const handlePageChange = (_, newPage) => setCurrentPage(newPage);

  return (
    <div
      className="min-w-1/2 flex h-full min-h-0 w-1/2 flex-col gap-2 rounded-[14px] p-4"
      style={{ backgroundColor: HNSColors.tertiary[975] }}
    >
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          <ServicesHeader
            title={STRINGS.HEADERS.AVAILABLE_SERVICES}
            selectedServices={selectedAvailableServices.length}
            totalServices={resultCount}
          />
          <SearchBar
            searchText={currentSearch}
            setSearchText={setCurrentSearch}
            resetCurrentPage={resetCurrentPage}
          />

          <ServicesList data={data} serviceType={STRINGS.SERVICE_TYPE.AVAILABLE} />
          {resultCount > STRINGS.DEFAULT_PAGINATION_LIMIT && (
            <div className={`flex w-full justify-center`}>
              <Stack alignItems="center">
                <PaginationControlsV2
                  alignment="center"
                  resultCount={resultCount}
                  handleChange={handlePageChange}
                  currentPage={currentPage}
                  resultLimit={resLimit}
                />
              </Stack>
            </div>
          )}
        </>
      )}
    </div>
  );
}
